import { UPDATE_LOST_XP } from '../types';
export const updateLostXp = _ref => {
  let {
    exerciseId,
    lostXp
  } = _ref;
  return {
    exerciseId,
    lostXp,
    type: UPDATE_LOST_XP
  };
};